import { ReactNode, RefObject, useCallback } from "react";

import useRowKeyboardNavigation from "ds/components/Table/hooks/useKeyboardNavigation/useRowKeyboardNavigation";
import useStickyRow from "ds/components/Table/hooks/useStickyRow";
import TableBodyRow from "ds/components/Table/Row";

type SpaceDetailsExpandableStickyRowProps = {
  children: ReactNode;
  keyboardProps: ReturnType<typeof useRowKeyboardNavigation>;
  measureRef: (node: HTMLDivElement | null) => void;
  dataIndex: number;
  isActiveSticky: boolean;
  nextAfterSticky?: number;
  tableRef: RefObject<HTMLDivElement | null>;
};

const SpaceDetailsExpandableStickyRow = ({
  children,
  keyboardProps,
  measureRef,
  dataIndex,
  isActiveSticky,
  nextAfterSticky,
  tableRef,
}: SpaceDetailsExpandableStickyRowProps) => {
  const rowRef = useStickyRow(isActiveSticky, nextAfterSticky, tableRef);

  const setRef = useCallback(
    (node: HTMLDivElement | null) => {
      measureRef(node);
      rowRef.current = node;
    },
    [measureRef, rowRef]
  );

  return (
    <TableBodyRow
      {...keyboardProps}
      dataIndex={dataIndex}
      virtualized
      ref={setRef}
      isGroupOpen={isActiveSticky}
    >
      {children}
    </TableBodyRow>
  );
};

export default SpaceDetailsExpandableStickyRow;
